module.exports = __webpack_public_path__ + "1f6f19848142b4db97c6f2ca11a545bb.svg";